import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "hidden lg:flex lg:items-center" }
const _hoisted_3 = {
  class: "ml-4 text-sm/6 font-semibold text-gray-900",
  "aria-hidden": "true"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {
  Menu, MenuButton, MenuItem, MenuItems,
} from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import useAuthStore from '@/store/auth';
import BlankProfilePicture from '@/assets/images/backgrounds/blank-profile-picture.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopUserMenu',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const { session, authDoLogout } = useAuthStore();

const profileImageUrl = computed(() => session?.profileImageUrl || BlankProfilePicture);
const firstName = computed(() => session?.name?.split(' ')[0] || '');
const profileHref = computed(() => router.resolve({ name: 'UserProfileManagerPage' }).href);
const integrationsHref = computed(() => router.resolve({ name: 'PluginsManagerPage' }).href);
const bioHref = computed(() => router.resolve({ name: 'UserBioManagerPage' }).href);
// Affiliate panel used to live only in the left nav of the old dashboard
// layout, which the plugin screens don't render — sellers there had no way
// to reach it. Sits last before the divider so logout stays isolated.
const affiliateHref = computed(() => router.resolve({ name: 'AffiliateDashboardPage' }).href);

const onLogout = async () => {
  try {
    await authDoLogout();
    window.open(router.resolve({ name: 'SessionLoginPage' }).href, '_self');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    // eslint-disable-next-line no-alert
    alert(t('session.logoutError'));
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MenuButton), { class: "-m-1.5 flex items-center p-1.5" }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)),
          _createElementVNode("img", {
            class: "size-8 rounded-full bg-gray-50",
            src: profileImageUrl.value,
            alt: ""
          }, null, 8, _hoisted_1),
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(firstName.value), 1),
            _createVNode(_unref(ChevronDownIcon), {
              class: "ml-2 size-5 text-gray-400",
              "aria-hidden": "true"
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuItems), { class: "bg-white absolute right-0 z-10 mt-2.5 w-48 origin-top-right rounded-md py-2 ring-1 shadow-lg ring-gray-900/5 focus:outline-hidden" }, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItem), null, {
                default: _withCtx(({ active }) => [
                  _createElementVNode("a", {
                    href: profileHref.value,
                    class: _normalizeClass([active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900'])
                  }, _toDisplayString(_unref(t)('sidemenu.navigation.profile.title')), 11, _hoisted_4)
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), null, {
                default: _withCtx(({ active }) => [
                  _createElementVNode("a", {
                    href: integrationsHref.value,
                    class: _normalizeClass([active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900'])
                  }, _toDisplayString(_unref(t)('plugins.manager.title')), 11, _hoisted_5)
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), null, {
                default: _withCtx(({ active }) => [
                  _createElementVNode("a", {
                    href: bioHref.value,
                    class: _normalizeClass([active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900'])
                  }, _toDisplayString(_unref(t)('sidemenu.navigation.bio.title')), 11, _hoisted_6)
                ]),
                _: 1
              }),
              _createVNode(_unref(MenuItem), null, {
                default: _withCtx(({ active }) => [
                  _createElementVNode("a", {
                    href: affiliateHref.value,
                    class: _normalizeClass([active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900'])
                  }, _toDisplayString(_unref(t)('sidemenu.navigation.affiliate-panel.title')), 11, _hoisted_7)
                ]),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "my-1 border-t border-gray-100" }, null, -1)),
              _createVNode(_unref(MenuItem), null, {
                default: _withCtx(({ active }) => [
                  _createElementVNode("a", {
                    href: "#",
                    class: _normalizeClass([active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900']),
                    onClick: _withModifiers(onLogout, ["prevent"])
                  }, _toDisplayString(_unref(t)('sidemenu.navigation.signout.title')), 3)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})